import type { IconComponent } from "./types";

export const Add: IconComponent = ({ ref, color = "currentColor", ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" ref={ref} {...props}>
      <path
        fill={color}
        d="M13.74 4.26a6.4 6.4 0 0 1 2 4.74c0 1.85-.67 3.44-2 4.77A6.46 6.46 0 0 1 9 15.74a6.58 6.58 0 0 1-4.77-1.97A6.58 6.58 0 0 1 2.26 9c0-1.85.65-3.43 1.97-4.74a6.52 6.52 0 0 1 4.77-2 6.4 6.4 0 0 1 4.74 2Zm1.09 10.57A7.94 7.94 0 0 0 17.25 9c0-2.27-.8-4.21-2.42-5.83A7.95 7.95 0 0 0 9 .75c-2.27 0-4.21.8-5.83 2.42A7.94 7.94 0 0 0 .75 9c0 2.27.8 4.21 2.42 5.83A7.94 7.94 0 0 0 9 17.25c2.27 0 4.21-.8 5.83-2.42Zm-5.1-8.81a.74.74 0 0 0-.1-.39.57.57 0 0 0-.24-.28.74.74 0 0 0-.39-.1.67.67 0 0 0-.53.24.71.71 0 0 0-.2.53v5.96c0 .21.06.4.2.57.14.14.32.2.53.2.21 0 .39-.06.53-.2a.84.84 0 0 0 .2-.57V6.02ZM6.03 8.26c-.21 0-.4.07-.57.21a.71.71 0 0 0-.2.53c0 .14.03.27.1.39a.8.8 0 0 0 .28.28c.12.04.25.07.39.07h5.96c.21 0 .39-.07.53-.21a.67.67 0 0 0 .25-.53.67.67 0 0 0-.25-.53.71.71 0 0 0-.53-.2H6.02Z"
      />
    </svg>
  );
};
Add.displayName = "Add";
Add.alias = ["plus"];
